import { Controller } from "@hotwired/stimulus"

// Accordion controller for inline lookup editing in settings
export default class extends Controller {
  static targets = ["row", "form", "submitButton", "cancelButton"]
  static values = {
    expandedId: String
  }
  static outlets = ["confirmation-modal"]

  connect() {
    this.expandedIdValue = ""
  }

  expand(event) {
    const button = event.currentTarget
    const lookupId = button.dataset.lookupId
    const row = button.closest("[data-lookup-row]")

    // Collapse any other expanded row first
    if (this.expandedIdValue && this.expandedIdValue !== lookupId) {
      this.collapseRow(this.expandedIdValue)
    }

    // Toggle current row
    if (this.expandedIdValue === lookupId) {
      this.collapseRow(lookupId)
      this.expandedIdValue = ""
    } else {
      this.expandRow(row, lookupId)
      this.expandedIdValue = lookupId
    }
  }

  expandRow(row, lookupId) {
    const form = row.querySelector("[data-lookup-form]")
    if (form) {
      form.classList.remove("hidden")
      // Focus first input
      const firstInput = form.querySelector("input:not([type=hidden])")
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 50)
      }
    }
  }

  collapseRow(lookupId) {
    const row = this.element.querySelector(`[data-lookup-row][data-lookup-id="${lookupId}"]`)
    if (row) {
      const form = row.querySelector("[data-lookup-form]")
      if (form) {
        form.classList.add("hidden")
      }
    }
  }

  collapse(event) {
    event?.preventDefault()
    if (this.expandedIdValue) {
      this.collapseRow(this.expandedIdValue)
      this.expandedIdValue = ""
    }
    // Also collapse the "new" form if open
    const newForm = this.element.querySelector("[data-lookup-form-new]")
    if (newForm) {
      newForm.classList.add("hidden")
    }
  }

  showNew(event) {
    event.preventDefault()

    // Collapse any expanded edit form
    if (this.expandedIdValue) {
      this.collapseRow(this.expandedIdValue)
      this.expandedIdValue = ""
    }

    const newForm = this.element.querySelector("[data-lookup-form-new]")
    if (newForm) {
      newForm.classList.toggle("hidden")
      if (!newForm.classList.contains("hidden")) {
        const firstInput = newForm.querySelector("input:not([type=hidden])")
        if (firstInput) {
          setTimeout(() => firstInput.focus(), 50)
        }
      }
    }
  }

  submitStart(event) {
    // Disable submit buttons
    this.submitButtonTargets.forEach(btn => {
      btn.disabled = true
      btn.classList.add("opacity-50")
    })
  }

  submitEnd(event) {
    // Re-enable submit buttons
    this.submitButtonTargets.forEach(btn => {
      btn.disabled = false
      btn.classList.remove("opacity-50")
    })
    // Collapse after successful submit (Turbo will replace content)
    this.expandedIdValue = ""
  }

  confirmDelete(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const form = button.closest('form')
    const message = button.dataset.confirmMessage || "Ar tikrai norite ištrinti šį įrašą?"

    if (this.hasConfirmationModalOutlet) {
      this.confirmationModalOutlet.show("Ištrinti įrašą", message, () => {
        form.requestSubmit()
      })
    } else {
      // Fallback to native confirm if modal not available
      if (confirm(message)) {
        form.requestSubmit()
      }
    }
  }
}
